





































































import { defineComponent, PropType, computed } from '@vue/composition-api'
import { mdiDotsVertical } from '@mdi/js'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'
import { AggregationUserAttrs } from '@/api/v2/report/AggregationUser'
import { useAggregationType } from '../composables/useAggregationType'
import { UserAttrs } from '@/api/v2/report/Aggregation'
import { BRDisplayType, DisplayMode } from '../composables/useAggregationResultTable'
import DataTableCopyListItemBtn from '@/views/v2-temp/common/components/DataTableCopyListItemBtn.vue'
import AggregationUsersDialogListItem from './AggregationUsersDialogListItem.vue'
import BRDisplaySettingsDialogListItem from './BRDisplaySettingsDialogListItem.vue'

interface Item {
  [key: string]: any;
  [key: number]: any;
}
interface Header {
  [key: string]: any;
  [key: number]: any;
}

export default defineComponent({
  name: 'AggregationTableMenu',
  components: {
    DataTableCopyListItemBtn,
    AggregationUsersDialogListItem,
    BRDisplaySettingsDialogListItem,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    displayMode: {
      type: String as PropType<DisplayMode>,
      default: 'daily',
    },
    aggregation: {
      type: Object as PropType<AggregationResultAttributes>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      default: () => [],
    },
    headers: {
      type: Array as PropType<Header[]>,
      default: () => [],
    },
    availableUsers: {
      type: Array as PropType<UserAttrs[]>,
      default: () => [],
    },
    aggregationUsers: {
      type: Array as PropType<AggregationUserAttrs[]>,
      default: () => [],
    },
    displaySumRow: {
      type: Boolean,
      default: false,
    },
    sumRow: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    },
    hideZeroRows: {
      type: Boolean,
      default: false,
    },
    brDisplaySettings: {
      type: Object as PropType<Record<string, BRDisplayType>>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { isUserAggregation } = useAggregationType(props.aggregation)

    const brDisplayTypeItems = [
      { text: '合計', value: 'sum' },
      { text: 'ユニーク', value: 'unique' },
      { text: '最大', value: 'max' },
      { text: '最終値', value: 'last' },
      { text: '平均', value: 'avg' },
      { text: '非表示', value: 'hidden' },
    ]

    const businessRuleHeaders = computed(() => props.aggregation.businessRules.data.map(r => ({
      text: r.attributes.name,
      value: r.id,
    })))

    const handleFetchAvailableUsers = async (callback: () => void) => {
      emit('fetch-available-users', callback)
    }

    const handleCreateAggregationUser = async ({ userId, callback }: { userId: number, callback: () => void }) => {
      emit('create-aggregation-user', { userId, callback })
    }

    const handleDestroyAggregationUser = async ({ id, userId, callback }: { id: number, userId: number, callback: () => void }) => {
      emit('destroy-aggregation-user', { id, userId, callback })
    }

    const handleToggleSumRow = () => {
      emit('toggle-sum-row')
    }

    const sumRowMessage = computed(() => {
      return props.displaySumRow ? '合計行を非表示' : '合計行を表示'
    })

    return {
      isUserAggregation,
      handleFetchAvailableUsers,
      handleCreateAggregationUser,
      handleDestroyAggregationUser,
      handleToggleSumRow,
      sumRowMessage,
      brDisplayTypeItems,
      businessRuleHeaders,
      cancel: (menu: { value: boolean }) => {
        // eslint-disable-next-line no-param-reassign
        menu.value = false
      },
      icons: {
        mdiDotsVertical,
      },
    }
  },
})
